import { registerComponent } from '@gig/magic-common';
export { GameTag } from './tag.js';
import TagComponent from './tag.vue.js';

var Tag = registerComponent(TagComponent);

export { Tag };
